<template>
  <div>

    <button @click.prevent="active = !active" class="hamburger btn-reset d-lg-none" id="menu_toggle">
      <span class="main-nav-toggle" :class="{'active': active}"></span>
    </button>

    <nav id="side_menu" :class="{'active': active}">
      <ul v-if="items" ref="menu" class="list-unstyled p-2 position-relative">
          <li class="guide-text2" v-for="i in items" :key="i.id" :id="'menu_id_' + i.id">
            <div class="d-inline-block">
              <a 
                class="d-inline-block link-wrap"
                @click="active = false"
                v-lazy:background-image="i.bg_img ? i.bg_img.url_resized_large : ''"
                :style="{backgroundColor: '#' + i.bg_color, color: '#' + i.text_color}" 
                :href="'#' + $t(iKey('related_menu_items', i, 'section_id'))">{{ $t(iKey('related_menu_items', i, 'section_label')) }}
                </a>
            </div>
          </li>
          <li class="guide-text2">
            <div class="d-inline-block">
              <div class="link-wrap lang" :style="{backgroundColor: '#382E2B'}">
                <a class="d-inline-block pr-2" :class="{'current': $i18n.locale == 'en'}" v-on:click.prevent="switchLang('en')" href="#">EN</a>
                <span style="color: white"> | </span>
                <a class="d-inline-block pl-2" :class="{'current': $i18n.locale == 'fr'}" v-on:click.prevent="switchLang('fr')" href="#">FR</a>
              </div>
            </div>
          </li>
      </ul>
    </nav>

    <transition name="fade-scrim">
      <div v-if="active" class="scrim vh-100 vw-100 d-md-none"></div>
    </transition>

  </div>
  
</template>

<script>

export default {
  name: 'SideMenu',
  props: [
    'items'
  ],
  data: () => {
    return {
      hidden: false,
      active: false
    }
  },
  mounted(){
    // move menu back to top after scrolling when there is an announcement banner
    var dur = this.windowHeight * 2;
    const scene = this.$scrollmagic.scene({
        triggerElement: '#app',
        triggerHook: 0,
        duration: dur
        
    });

    this.$scrollmagic.addScene(
      scene.setClassToggle('#menu_toggle', 'top')
    );
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .scrim {
    position: fixed;
    top: 0;
    left: 0;
    opacity: 0.7;
    background-color: black;
    z-index: 1000;
  }

  .fade-scrim-enter,
  .fade-scrim-leave-to {
    opacity: 0;
  }
  .fade-scrim-enter-active,
  .fade-scrim-leave-active {
    transition: opacity 0.5s;
  }

#side_menu {
    position: fixed;
    left: -150px;
    top: 50%;
    z-index: 1001; 
    transform: translate(0%,-50%);
    overflow-x: hidden;
    pointer-events: none;
    transition: left 0.5s ease;
}
#side_menu.active {
  left: -20px;
}
@media (min-width: 992px) {
  #side_menu {
    left: -10px;
  }
}

#side_menu li .link-wrap{
  line-height: 10px;
  padding: 10px 85px 10px 35px;
  text-transform: uppercase;
  pointer-events: auto;
  position: relative;
  left: -80%;
  transition: all 0.3s ease;
  backface-visibility: hidden;
}
#side_menu.active .link-wrap{
  left: 0;
  padding-right: 35px;
}
@media (hover: hover){
  #side_menu li .link-wrap:hover{
    left: 0;
    padding-right: 35px;
  }
}
@media (min-width: 992px) {
  #side_menu.active .link-wrap{
    left: -80%;
  }
}
@media (min-width: 992px) {
  #side_menu li .link-wrap,
  #side_menu li .link-wrap.lang {
    line-height: initial;
  }
}
/* use smaller menu that is flex-wrapped for mobile landscape */
@media (max-height: 480px) and (max-width: 992px) and (orientation: landscape) {
  #side_menu ul {
      display: flex;
      flex-wrap: wrap;
      width: 360px;
      margin: 1rem auto 0;
  }

  #side_menu li .link-wrap{
    left: -110%;
  }
}


.link-wrap.lang a {
  color: #ffffff;
 }
 .link-wrap.lang a.current {
   text-decoration: underline;
 }

#menu_toggle {
  position: fixed;
  left: 5px;
  top: 5px;
  z-index: 1001; 
  background-color: rgba(56,46,43,1);
  height: 40px;
  width: 40px;
  transition: top 300ms ease-in-out;
  
  pointer-events: auto;
}

/* top position for when there is an announcement banner */
#menu_toggle.top {
  top: 95px;
}

@media (min-height: 480px) and (max-height: 640px) {
  #menu_toggle.top {
    top: 75px;
  }
}

@media (max-height: 480px) and (orientation: landscape) { 
  #menu_toggle.top {
    top: 5px;
  }
}

.hamburger {
  display: inline-block;
}
.hamburger .main-nav-toggle {
  pointer-events: none;
  display: block;
  width: 22px;
  height: 10px;
  left: 9px;
  position: absolute;
  top: 12px;
}
.hamburger .main-nav-toggle:after, .hamburger .main-nav-toggle:before {
  content: '';
  position: absolute;
  top: 0;
  height: 0;
  border-bottom: 4px solid white;
  width: 100%;
  left: 0;
  right: 0;
  transition: all ease-out 0.3s;
  backface-visibility: hidden;
}
.hamburger .main-nav-toggle:after {
  top: 100%;
}
.hamburger .main-nav-toggle i {
  display: block;
  text-indent: 100%;
  overflow: hidden;
  white-space: nowrap;
  height: 4px;
  background-color: #bbb;
  width: 100%;
  position: absolute;
  top: 50%;
  transition: all ease-out 0.1s;
}
.hamburger .main-nav-toggle.active:after {
  transform: rotate(-45deg);
  transform-origin: center;
  top: 50%;
}
.hamburger .main-nav-toggle.active:before {
  transform: rotate(45deg);
  transform-origin: center;
  top: 50%;
}
.hamburger .main-nav-toggle.active i {
  opacity: 0;
}

</style>
